<template>
  <div>
    Auth Handler
  </div>
</template>

<script>
export default {
  mounted () {
    console.log('Auth mounted')
  },
  updated () {
    console.log('Auth updated')
  }
}
</script>